import React, { useEffect } from 'react'

import { SVGInjector } from '@tanem/svg-injector'
import debounce from 'lodash/debounce'

import bpAdmin from '../../../../../assets/data/bpAdmin.json'
import { GlobalAlert } from '../../../../components'
import { MaintenanceMode, Responsive, TopNavigation, Workspace } from '../../../../containers'
import { APP_CONFIG } from '../../common/constants'
import { AboutModal } from '../../components'
import DesktopView from '../DesktopView'
import MobileView from '../MobileView'
import PrintView from '../PrintView'
import TabletView from '../TabletView'

const PageView = () => {
  const setMediaClass = (width) => {
    let mediaClass = null

    if (width < 768) {
      mediaClass = '-media-xs'
    } else if (width < 992) {
      mediaClass = '-media-sm'
    } else if (width < 1600) {
      mediaClass = '-media-md'
    } else {
      mediaClass = '-media-lg'
    }
    document.documentElement.classList.remove('-media-xs', '-media-sm', '-media-md', '-media-lg')
    document.documentElement.classList.add(mediaClass)
  }

  useEffect(() => {
    const mySVGsToInject = document.querySelectorAll('img.injectSVG')
    SVGInjector(mySVGsToInject)

    document.documentElement.classList.add(APP_CONFIG.productThemeClasses)
  }, [])

  useEffect(() => {
    setMediaClass(window.innerWidth)
  }, [])

  useEffect(() => {
    const debouncedHandleResize = debounce(() => setMediaClass(window.innerWidth), 500)

    window.addEventListener('resize', debouncedHandleResize)

    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  }, [])

  return (
    <React.Fragment>
      <TopNavigation about={AboutModal} appConfig={APP_CONFIG} print={PrintView} />

      {bpAdmin && bpAdmin.applications[APP_CONFIG.appCode] === 'off' ? (
        <MaintenanceMode appCode={APP_CONFIG.appCode} appName={APP_CONFIG.appName} />
      ) : (
        <Workspace>
          <GlobalAlert />
          <Responsive.Desktop>
            <DesktopView />
          </Responsive.Desktop>
          <Responsive.Tablet>
            <TabletView />
          </Responsive.Tablet>
          <Responsive.Mobile>
            <MobileView />
          </Responsive.Mobile>
        </Workspace>
      )}
    </React.Fragment>
  )
}

export default PageView
